export default {
    NUMERICAL: 'numerical',
    CATEGORICAL: 'categorical',
    TEMPORAL: 'temporal',
    GEOGRAPHICAL: 'geographical',
    Text:'text'
}